export function dateFormat(s) {
    return s ? s.slice(0, 2) + '.' + s.slice(3, 5) + s.slice(5, 10): ''
}

export function intFormat(s) {
    if (s.length === 0) {
        return 0
    }
    const nums = '0123456789'
    let new_s = ''
    let ind = 0
    while (s[ind] === '0' && ind < s.length-1) {
        ind++
    }

    for (let i=ind; i<s.length; i++) {
        if (nums.indexOf(s[i]) > -1) {
            new_s = new_s + s[i]
        }
    }

    return new_s
}